import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import TextSection from "../template/TextSection";
import KpsEditor from "../editor/KpsEditor";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { Trans, withTranslation } from "react-i18next";
import DisplayDecisionTree from "../tree/DisplayDecisionTree";
import Dialog from "@material-ui/core/Dialog";
import DecisionTree from "../tree/DecisionTree";
import { CardActions } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorIcon from "@material-ui/icons/Error";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  error: {
    color: theme.palette.error.light,
  },
});
class EditDecisionTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      incomplete: true,
      section: null,
      dirty: false,
    };
  }
  componentDidMount() {
    this.setState({ section: this.props.section });
  }
  render() {
    const { classes, t } = this.props;
    return (
      // <Dialog open={this.props.edit} fullScreen>
      //   {this.props.edit && (
      this.props.edit &&
      this.state.section && (
        <>
          {/* <CardContent style={{ height: "100%", overflowY: "auto" }}> */}
          <DecisionTree
            handleChange={(tree) => {
              let section = { ...this.state.section, defaultText: JSON.stringify(tree)  };
              this.setState({
                dirty: !!(this.props.onChangeSection), //sets dirty only if this functionality is enabled with a listener
                section: section,
              })
              if(this.props.onChangeSection){
                this.props.onChangeSection(section);
              }
            }}
            title={this.state.section.name}
            tree={
              JSON.parse(this.state.section.defaultText)
            }
            setIncomplete={(incomplete) => this.setState({ incomplete })}
          />
          {/* </CardContent> */}
          <DialogActions>
            <Button onClick={this.props.openEdit}>
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              style = {{border:  this.state.dirty ? "2px dotted red" :""}} // dirty only set when a listener has been added to props. 
              onClick={() =>
                this.props.update({
                  ...this.state.section,
                  defaultText: this.state.section.defaultText,
                })
              }
            >
              <Trans i18nKey="global_ok" />
            </Button>
            {this.state.incomplete &&
              this.state.section.type === "tree" && (
                <Tooltip
                  title={t("decision_tree_incomplete")}
                  aria-label={t("decision_tree_incomplete")}
                >
                  <ErrorIcon className={classes.error} />
                </Tooltip>
              )}
          </DialogActions>
        </>
      )
      //   )}
      // </Dialog>
    );
  }
}
export default withStyles(styles)(withTranslation()(EditDecisionTree));
